import React from 'react';
import styled from 'styled-components';
import { Subtract20Regular } from '@fluentui/react-icons';

const ButtonWrapper = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  &:hover {
    background-color:rgb(255, 255, 255);
    border-radius: 4px;
    color: #0078d4;
  }

  svg {
    width: 20px;
    height: 20px;
    fill: #0078d4;
  }
`;

interface CloseButtonProps {
  onClick: () => void;
  ariaLabel?: string;
}

export const ButtonMinus: React.FC<CloseButtonProps> = ({
  onClick,
  ariaLabel = 'Закрыть',
}) => {
  return (
    <ButtonWrapper onClick={onClick} aria-label={ariaLabel}>
      <Subtract20Regular />
    </ButtonWrapper>
  );
};